/* tslint:disable */
/* eslint-disable */
/**
 * 
 * @export
 * @interface Alternative
 */
export interface Alternative {
    /**
     * 
     * @type {string}
     * @memberof Alternative
     */
    storageName: string;
    /**
     * 
     * @type {string}
     * @memberof Alternative
     */
    path: string;
}
/**
 * 
 * @export
 * @interface BatchMoveRequest
 */
export interface BatchMoveRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchMoveRequest
     */
    newpaths: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchMoveRequest
     */
    oldpaths: Array<string>;
}
/**
 * 
 * @export
 * @interface CheckState200Response
 */
export interface CheckState200Response {
    /**
     * 
     * @type {ConnectionState}
     * @memberof CheckState200Response
     */
    state: ConnectionState;
}
/**
 * 
 * @export
 * @interface ColumnMetadata
 */
export interface ColumnMetadata {
    /**
     * 
     * @type {string}
     * @memberof ColumnMetadata
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof ColumnMetadata
     */
    populatedSortKey?: string;
    /**
     * 
     * @type {ColumnMetadataProperties}
     * @memberof ColumnMetadata
     */
    properties: ColumnMetadataProperties;
}
/**
 * 
 * @export
 * @interface ColumnMetadataProperties
 */
export interface ColumnMetadataProperties {
    /**
     * 
     * @type {boolean}
     * @memberof ColumnMetadataProperties
     */
    searchable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ColumnMetadataProperties
     */
    sortable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ColumnMetadataProperties
     */
    hidden: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ConnectionState {
    CONNECTED = 'connected',
    AUTH_FAILURE = 'auth_failure',
    SERVER_ERROR = 'server_error',
    MISSING_PERMISSIONS = 'missing_permissions',
    UNKNOWN = 'unknown'
}

/**
 * 
 * @export
 * @interface DataTableManual
 */
export interface DataTableManual {
    /**
     * 
     * @type {Array<Manual>}
     * @memberof DataTableManual
     */
    items: Array<Manual>;
    /**
     * 
     * @type {number}
     * @memberof DataTableManual
     */
    total: number;
}
/**
 * 
 * @export
 * @interface DataTableMeta
 */
export interface DataTableMeta {
    /**
     * 
     * @type {Array<ColumnMetadata>}
     * @memberof DataTableMeta
     */
    columns: Array<ColumnMetadata>;
    /**
     * 
     * @type {Array<SortOption>}
     * @memberof DataTableMeta
     */
    defaultSort?: Array<SortOption>;
    /**
     * 
     * @type {boolean}
     * @memberof DataTableMeta
     */
    isDefaultSort?: boolean;
}
/**
 * 
 * @export
 * @interface DataTableSolrSearchResult
 */
export interface DataTableSolrSearchResult {
    /**
     * 
     * @type {Array<SolrSearchResult>}
     * @memberof DataTableSolrSearchResult
     */
    items: Array<SolrSearchResult>;
    /**
     * 
     * @type {number}
     * @memberof DataTableSolrSearchResult
     */
    total: number;
}
/**
 * 
 * @export
 * @interface DataTableStorageWithIndexCount
 */
export interface DataTableStorageWithIndexCount {
    /**
     * 
     * @type {Array<StorageWithIndexCount>}
     * @memberof DataTableStorageWithIndexCount
     */
    items: Array<StorageWithIndexCount>;
    /**
     * 
     * @type {number}
     * @memberof DataTableStorageWithIndexCount
     */
    total: number;
}
/**
 * 
 * @export
 * @interface EditStorageRequest
 */
export interface EditStorageRequest {
    /**
     * 
     * @type {Features}
     * @memberof EditStorageRequest
     */
    features?: Features;
    /**
     * 
     * @type {string}
     * @memberof EditStorageRequest
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface Features
 */
export interface Features {
    /**
     * 
     * @type {boolean}
     * @memberof Features
     */
    read: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Features
     */
    write: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Features
     */
    versioning: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Features
     */
    trashbin: boolean;
}
/**
 * 
 * @export
 * @interface FileVersion
 */
export interface FileVersion {
    /**
     * 
     * @type {string}
     * @memberof FileVersion
     */
    originalPath: string;
    /**
     * 
     * @type {string}
     * @memberof FileVersion
     */
    fullPath: string;
    /**
     * 
     * @type {string}
     * @memberof FileVersion
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof FileVersion
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof FileVersion
     */
    userId: string;
}
/**
 * 
 * @export
 * @interface GetManual200Response
 */
export interface GetManual200Response {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetManual200Response
     */
    paths: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetManual200Response
     */
    title: string;
}
/**
 * 
 * @export
 * @interface GetSchedulerStatus200Response
 */
export interface GetSchedulerStatus200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetSchedulerStatus200Response
     */
    running: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetSchedulerStatus200Response
     */
    totalTenant: number;
    /**
     * 
     * @type {string}
     * @memberof GetSchedulerStatus200Response
     */
    nextRefresh: string;
}
/**
 * 
 * @export
 * @interface GetThemeSettings200Response
 */
export interface GetThemeSettings200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetThemeSettings200Response
     */
    useThemeLogo: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetThemeSettings200Response
     */
    useStandardTheme: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum IndexRefreshState {
    SUCCESSFUL = 'successful',
    PARTIAL = 'partial',
    FAILED = 'failed',
    RUNNING = 'running',
    NOT_STARTED = 'not_started'
}

/**
 * 
 * @export
 * @interface List200Response
 */
export interface List200Response {
    /**
     * 
     * @type {number}
     * @memberof List200Response
     */
    total: number;
    /**
     * 
     * @type {Array<News>}
     * @memberof List200Response
     */
    items: Array<News>;
}
/**
 * 
 * @export
 * @interface ListsRequest
 */
export interface ListsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ListsRequest
     */
    paths: Array<string>;
}
/**
 * 
 * @export
 * @interface Manual
 */
export interface Manual {
    /**
     * 
     * @type {number}
     * @memberof Manual
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Manual
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Manual
     */
    persist: boolean;
    /**
     * 
     * @type {string}
     * @memberof Manual
     */
    accessKey: string | null;
    /**
     * 
     * @type {string}
     * @memberof Manual
     */
    path: string;
    /**
     * 
     * @type {string}
     * @memberof Manual
     */
    name: string | null;
    /**
     * 
     * @type {Array<ManualSortEntry>}
     * @memberof Manual
     */
    sort?: Array<ManualSortEntry>;
    /**
     * 
     * @type {boolean}
     * @memberof Manual
     */
    useStandardTheme: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Manual
     */
    useThemeLogo: boolean;
    /**
     * 
     * @type {ManualStorage}
     * @memberof Manual
     */
    storage: ManualStorage;
}
/**
 * 
 * @export
 * @interface ManualSortEntry
 */
export interface ManualSortEntry {
    /**
     * 
     * @type {string}
     * @memberof ManualSortEntry
     */
    key: string;
    /**
     * 
     * @type {number}
     * @memberof ManualSortEntry
     */
    value: number;
}
/**
 * 
 * @export
 * @interface ManualStorage
 */
export interface ManualStorage {
    /**
     * 
     * @type {number}
     * @memberof ManualStorage
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ManualStorage
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ManualStorage
     */
    tenant: string;
}
/**
 * 
 * @export
 * @interface ManualWithPassword
 */
export interface ManualWithPassword {
    /**
     * 
     * @type {number}
     * @memberof ManualWithPassword
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ManualWithPassword
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ManualWithPassword
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ManualWithPassword
     */
    persist: boolean;
    /**
     * 
     * @type {string}
     * @memberof ManualWithPassword
     */
    accessKey: string;
    /**
     * 
     * @type {Array<ManualSortEntry>}
     * @memberof ManualWithPassword
     */
    sort?: Array<ManualSortEntry>;
    /**
     * 
     * @type {boolean}
     * @memberof ManualWithPassword
     */
    useStandardTheme: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ManualWithPassword
     */
    useThemeLogo: boolean;
    /**
     * 
     * @type {PickManualExcludeKeyofManualPathOrNewsStorage}
     * @memberof ManualWithPassword
     */
    storage: PickManualExcludeKeyofManualPathOrNewsStorage;
    /**
     * 
     * @type {boolean}
     * @memberof ManualWithPassword
     */
    news: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ManualWithPassword
     */
    password: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum Mime {
    'text/plain' = 'text/plain',
    'text/csv' = 'text/csv',
    'text/markdown' = 'text/markdown',
    'application/text' = 'application/text',
    'application/json' = 'application/json',
    'application/javascript' = 'application/javascript',
    'application/pdf' = 'application/pdf',
    'raw' = 'raw',
    'image/png' = 'image/png',
    'image/jpeg' = 'image/jpeg',
    'image/webp' = 'image/webp',
    'image/svg+xml' = 'image/svg+xml',
    'image/gif' = 'image/gif',
    'application/yaml' = 'application/yaml',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation' = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.ms-excel' = 'application/vnd.ms-excel',
    'application/vnd.ms-powerpoint' = 'application/vnd.ms-powerpoint',
    'application/msword' = 'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document' = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum MimeCategory {
    Text = 'text',
    Image = 'image',
    Code = 'code',
    Markdown = 'markdown',
    Pdf = 'pdf',
    Raw = 'raw',
    Folder = 'folder',
    Office = 'office'
}

/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    stack?: string;
}
/**
 * 
 * @export
 * @interface News
 */
export interface News {
    /**
     * 
     * @type {number}
     * @memberof News
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    date: string;
    /**
     * 
     * @type {NewsManual}
     * @memberof News
     */
    manual: NewsManual;
    /**
     * 
     * @type {number}
     * @memberof News
     */
    version: number;
}
/**
 * 
 * @export
 * @interface NewsManual
 */
export interface NewsManual {
    /**
     * 
     * @type {number}
     * @memberof NewsManual
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NewsManual
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NewsManual
     */
    persist: boolean;
    /**
     * 
     * @type {string}
     * @memberof NewsManual
     */
    accessKey: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsManual
     */
    path: string;
    /**
     * 
     * @type {string}
     * @memberof NewsManual
     */
    name: string | null;
    /**
     * 
     * @type {Array<ManualSortEntry>}
     * @memberof NewsManual
     */
    sort?: Array<ManualSortEntry>;
    /**
     * 
     * @type {boolean}
     * @memberof NewsManual
     */
    useStandardTheme: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NewsManual
     */
    useThemeLogo: boolean;
    /**
     * 
     * @type {ManualStorage}
     * @memberof NewsManual
     */
    storage: ManualStorage;
}
/**
 * 
 * @export
 * @interface NotifyLockEvent
 */
export interface NotifyLockEvent {
    /**
     * 
     * @type {NotifyLockEventEnum}
     * @memberof NotifyLockEvent
     */
    type: NotifyLockEventEnum;
    /**
     * 
     * @type {string}
     * @memberof NotifyLockEvent
     */
    path: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotifyLockEvent
     */
    owner?: boolean;
    /**
     * 
     * @type {NotifyLockEventUser}
     * @memberof NotifyLockEvent
     */
    user?: NotifyLockEventUser;
    /**
     * 
     * @type {string}
     * @memberof NotifyLockEvent
     */
    tenant?: string;
    /**
     * 
     * @type {string}
     * @memberof NotifyLockEvent
     */
    organisation?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum NotifyLockEventEnum {
    Subscribe = 0,
    Unsubscribe = 1,
    RevivingLock = 2,
    RevivedLock = 3,
    LockLost = 4
}

/**
 * 
 * @export
 * @interface NotifyLockEventUser
 */
export interface NotifyLockEventUser {
    /**
     * 
     * @type {string}
     * @memberof NotifyLockEventUser
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof NotifyLockEventUser
     */
    id: string;
}
/**
 * Make all properties in T optional
 * @export
 * @interface PartialRecordKeyofSolrDocumentString
 */
export interface PartialRecordKeyofSolrDocumentString {
    /**
     * 
     * @type {string}
     * @memberof PartialRecordKeyofSolrDocumentString
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordKeyofSolrDocumentString
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordKeyofSolrDocumentString
     */
    tenant?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordKeyofSolrDocumentString
     */
    path?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordKeyofSolrDocumentString
     */
    _version_?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordKeyofSolrDocumentString
     */
    search_content?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordKeyofSolrDocumentString
     */
    docId?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordKeyofSolrDocumentString
     */
    isTrashbin?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordKeyofSolrDocumentString
     */
    isVersioning?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordKeyofSolrDocumentString
     */
    size?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordKeyofSolrDocumentString
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordKeyofSolrDocumentString
     */
    tags?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordKeyofSolrDocumentString
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordKeyofSolrDocumentString
     */
    storageId?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordKeyofSolrDocumentString
     */
    mime?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordKeyofSolrDocumentString
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordKeyofSolrDocumentString
     */
    extractedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialRecordKeyofSolrDocumentString
     */
    _root_?: string;
}
/**
 * From T, pick a set of properties whose keys are in the union K
 * @export
 * @interface PickManualExcludeKeyofManualPathOrNews
 */
export interface PickManualExcludeKeyofManualPathOrNews {
    /**
     * 
     * @type {number}
     * @memberof PickManualExcludeKeyofManualPathOrNews
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PickManualExcludeKeyofManualPathOrNews
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof PickManualExcludeKeyofManualPathOrNews
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PickManualExcludeKeyofManualPathOrNews
     */
    persist: boolean;
    /**
     * 
     * @type {string}
     * @memberof PickManualExcludeKeyofManualPathOrNews
     */
    accessKey: string;
    /**
     * 
     * @type {Array<ManualSortEntry>}
     * @memberof PickManualExcludeKeyofManualPathOrNews
     */
    sort?: Array<ManualSortEntry>;
    /**
     * 
     * @type {boolean}
     * @memberof PickManualExcludeKeyofManualPathOrNews
     */
    useStandardTheme: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PickManualExcludeKeyofManualPathOrNews
     */
    useThemeLogo: boolean;
    /**
     * 
     * @type {PickManualExcludeKeyofManualPathOrNewsStorage}
     * @memberof PickManualExcludeKeyofManualPathOrNews
     */
    storage: PickManualExcludeKeyofManualPathOrNewsStorage;
}
/**
 * 
 * @export
 * @interface PickManualExcludeKeyofManualPathOrNewsStorage
 */
export interface PickManualExcludeKeyofManualPathOrNewsStorage {
    /**
     * 
     * @type {number}
     * @memberof PickManualExcludeKeyofManualPathOrNewsStorage
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PickManualExcludeKeyofManualPathOrNewsStorage
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PickManualExcludeKeyofManualPathOrNewsStorage
     */
    tenant: string;
}
/**
 * From T, pick a set of properties whose keys are in the union K
 * @export
 * @interface PickStorageIdOrNameOrTenant
 */
export interface PickStorageIdOrNameOrTenant {
    /**
     * 
     * @type {number}
     * @memberof PickStorageIdOrNameOrTenant
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PickStorageIdOrNameOrTenant
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PickStorageIdOrNameOrTenant
     */
    tenant: string;
}
/**
 * 
 * @export
 * @interface RecordStringStorageNodeArrayOrErrorValue
 */
export interface RecordStringStorageNodeArrayOrErrorValue {
    /**
     * 
     * @type {string}
     * @memberof RecordStringStorageNodeArrayOrErrorValue
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RecordStringStorageNodeArrayOrErrorValue
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof RecordStringStorageNodeArrayOrErrorValue
     */
    stack?: string;
}
/**
 * 
 * @export
 * @interface RecordStringStorageNodeOrErrorValue
 */
export interface RecordStringStorageNodeOrErrorValue {
    /**
     * 
     * @type {string}
     * @memberof RecordStringStorageNodeOrErrorValue
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RecordStringStorageNodeOrErrorValue
     */
    type: RecordStringStorageNodeOrErrorValueTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof RecordStringStorageNodeOrErrorValue
     */
    size?: number;
    /**
     * 
     * @type {Mime}
     * @memberof RecordStringStorageNodeOrErrorValue
     */
    mime?: Mime;
    /**
     * 
     * @type {Features}
     * @memberof RecordStringStorageNodeOrErrorValue
     */
    features: Features;
    /**
     * 
     * @type {string}
     * @memberof RecordStringStorageNodeOrErrorValue
     */
    lastModified: string;
    /**
     * 
     * @type {number}
     * @memberof RecordStringStorageNodeOrErrorValue
     */
    sizeInBytes?: number;
    /**
     * 
     * @type {number}
     * @memberof RecordStringStorageNodeOrErrorValue
     */
    elementsInside?: number;
    /**
     * 
     * @type {number}
     * @memberof RecordStringStorageNodeOrErrorValue
     */
    totalElementsInside?: number;
    /**
     * 
     * @type {string}
     * @memberof RecordStringStorageNodeOrErrorValue
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof RecordStringStorageNodeOrErrorValue
     */
    stack?: string;
}

/**
* @export
* @enum {string}
*/
export enum RecordStringStorageNodeOrErrorValueTypeEnum {
    Bin = 'bin'
}

/**
 * 
 * @export
 * @interface ReferencesOutput
 */
export interface ReferencesOutput {
    /**
     * 
     * @type {Array<string>}
     * @memberof ReferencesOutput
     */
    references: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReferencesOutput
     */
    referencedBy: Array<string>;
}
/**
 * 
 * @export
 * @interface RefreshAccessKey200Response
 */
export interface RefreshAccessKey200Response {
    /**
     * 
     * @type {string}
     * @memberof RefreshAccessKey200Response
     */
    accessKey: string;
}
/**
 * 
 * @export
 * @interface RestoreBackup200Response
 */
export interface RestoreBackup200Response {
    /**
     * 
     * @type {Array<string>}
     * @memberof RestoreBackup200Response
     */
    failedPaths: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof RestoreBackup200Response
     */
    failedProcesses: number;
    /**
     * 
     * @type {number}
     * @memberof RestoreBackup200Response
     */
    entriesCount: number;
}
/**
 * 
 * @export
 * @interface SearchTableQuery
 */
export interface SearchTableQuery {
    /**
     * 
     * @type {string}
     * @memberof SearchTableQuery
     */
    query?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchTableQuery
     */
    fullSearch?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SearchTableQuery
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof SearchTableQuery
     */
    itemsPerPage: number;
    /**
     * 
     * @type {Array<SortOption>}
     * @memberof SearchTableQuery
     */
    sortBy?: Array<SortOption>;
    /**
     * 
     * @type {boolean}
     * @memberof SearchTableQuery
     */
    showTrashbin?: boolean;
    /**
     * 
     * @type {SolrSearchMode}
     * @memberof SearchTableQuery
     */
    searchMode: SolrSearchMode;
    /**
     * 
     * @type {boolean}
     * @memberof SearchTableQuery
     */
    isViewMode?: boolean;
    /**
     * 
     * @type {Array<MimeCategory>}
     * @memberof SearchTableQuery
     */
    categories?: Array<MimeCategory>;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchTableQuery
     */
    storages?: Array<number>;
}
/**
 * 
 * @export
 * @interface SetConfigRequest
 */
export interface SetConfigRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SetConfigRequest
     */
    useThemeLogo?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SetConfigRequest
     */
    useStandardTheme?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SetConfigRequest
     */
    news?: boolean;
    /**
     * 
     * @type {Array<ManualSortEntry>}
     * @memberof SetConfigRequest
     */
    sort?: Array<ManualSortEntry>;
    /**
     * 
     * @type {string}
     * @memberof SetConfigRequest
     */
    password?: string;
}
/**
 * 
 * @export
 * @interface ShareId200Response
 */
export interface ShareId200Response {
    /**
     * 
     * @type {boolean}
     * @memberof ShareId200Response
     */
    isNotIndexed: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShareId200Response
     */
    key: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SolrSearchMode {
    FULL = 'full',
    TITLE_ONLY = 'title_only',
    CONTENT_ONLY = 'content_only',
    TAG_ONLY = 'tag_only'
}

/**
 * 
 * @export
 * @interface SolrSearchResult
 */
export interface SolrSearchResult {
    /**
     * 
     * @type {string}
     * @memberof SolrSearchResult
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SolrSearchResult
     */
    docId: string;
    /**
     * 
     * @type {string}
     * @memberof SolrSearchResult
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SolrSearchResult
     */
    path: string;
    /**
     * 
     * @type {boolean}
     * @memberof SolrSearchResult
     */
    isTrashbin: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SolrSearchResult
     */
    isVersioning: boolean;
    /**
     * 
     * @type {string}
     * @memberof SolrSearchResult
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof SolrSearchResult
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof SolrSearchResult
     */
    storageId: number;
    /**
     * 
     * @type {string}
     * @memberof SolrSearchResult
     */
    storageName: string;
    /**
     * 
     * @type {string}
     * @memberof SolrSearchResult
     */
    mime?: string;
    /**
     * 
     * @type {string}
     * @memberof SolrSearchResult
     */
    category?: string;
    /**
     * 
     * @type {PartialRecordKeyofSolrDocumentString}
     * @memberof SolrSearchResult
     */
    highlights: PartialRecordKeyofSolrDocumentString;
    /**
     * 
     * @type {Array<string>}
     * @memberof SolrSearchResult
     */
    highlightFields: Array<SolrSearchResultHighlightFieldsEnum>;
}

/**
* @export
* @enum {string}
*/
export enum SolrSearchResultHighlightFieldsEnum {
    Id = 'id',
    Name = 'name',
    Tenant = 'tenant',
    Path = 'path',
    Version = '_version_',
    SearchContent = 'search_content',
    DocId = 'docId',
    IsTrashbin = 'isTrashbin',
    IsVersioning = 'isVersioning',
    Size = 'size',
    Content = 'content',
    Tags = 'tags',
    Type = 'type',
    StorageId = 'storageId',
    Mime = 'mime',
    Category = 'category',
    ExtractedAt = 'extractedAt',
    Root = '_root_'
}

/**
 * 
 * @export
 * @interface Sort200ResponseInner
 */
export interface Sort200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof Sort200ResponseInner
     */
    key: string;
    /**
     * 
     * @type {number}
     * @memberof Sort200ResponseInner
     */
    value: number;
    /**
     * 
     * @type {boolean}
     * @memberof Sort200ResponseInner
     */
    _exists?: boolean;
}
/**
 * 
 * @export
 * @interface SortOption
 */
export interface SortOption {
    /**
     * 
     * @type {string}
     * @memberof SortOption
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SortOption
     */
    direction: SortOptionDirectionEnum;
}

/**
* @export
* @enum {string}
*/
export enum SortOptionDirectionEnum {
    Asc = 'asc',
    Desc = 'desc'
}

/**
 * 
 * @export
 * @interface Storage
 */
export interface Storage {
    /**
     * 
     * @type {string}
     * @memberof Storage
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof Storage
     */
    id: number;
    /**
     * 
     * @type {StorageProviderType}
     * @memberof Storage
     */
    provider: StorageProviderType;
    /**
     * 
     * @type {Features}
     * @memberof Storage
     */
    features: Features;
    /**
     * 
     * @type {string}
     * @memberof Storage
     */
    lastModified: string;
    /**
     * 
     * @type {string}
     * @memberof Storage
     */
    lastBackup?: string;
    /**
     * 
     * @type {string}
     * @memberof Storage
     */
    lastBackedUpBy?: string;
    /**
     * 
     * @type {ConnectionState}
     * @memberof Storage
     */
    state: ConnectionState;
    /**
     * 
     * @type {IndexRefreshState}
     * @memberof Storage
     */
    indexRefreshState: IndexRefreshState;
    /**
     * 
     * @type {string}
     * @memberof Storage
     */
    lastIndexRefresh: string;
    /**
     * 
     * @type {string}
     * @memberof Storage
     */
    tenant: string;
    /**
     * 
     * @type {WebDAVConfig}
     * @memberof Storage
     */
    config: WebDAVConfig;
}
/**
 * 
 * @export
 * @interface StorageBin
 */
export interface StorageBin {
    /**
     * 
     * @type {string}
     * @memberof StorageBin
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StorageBin
     */
    type: StorageBinTypeEnum;
    /**
     * 
     * @type {Features}
     * @memberof StorageBin
     */
    features: Features;
    /**
     * 
     * @type {string}
     * @memberof StorageBin
     */
    lastModified: string;
    /**
     * 
     * @type {number}
     * @memberof StorageBin
     */
    elementsInside?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageBin
     */
    totalElementsInside?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageBin
     */
    sizeInBytes?: number;
}

/**
* @export
* @enum {string}
*/
export enum StorageBinTypeEnum {
    Bin = 'bin'
}

/**
 * 
 * @export
 * @interface StorageDirectory
 */
export interface StorageDirectory {
    /**
     * 
     * @type {string}
     * @memberof StorageDirectory
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StorageDirectory
     */
    type: StorageDirectoryTypeEnum;
    /**
     * 
     * @type {Features}
     * @memberof StorageDirectory
     */
    features: Features;
    /**
     * 
     * @type {string}
     * @memberof StorageDirectory
     */
    lastModified: string;
    /**
     * 
     * @type {number}
     * @memberof StorageDirectory
     */
    elementsInside?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageDirectory
     */
    totalElementsInside?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageDirectory
     */
    sizeInBytes?: number;
}

/**
* @export
* @enum {string}
*/
export enum StorageDirectoryTypeEnum {
    Directory = 'directory'
}

/**
 * 
 * @export
 * @interface StorageFile
 */
export interface StorageFile {
    /**
     * 
     * @type {string}
     * @memberof StorageFile
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StorageFile
     */
    type: StorageFileTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof StorageFile
     */
    size?: number;
    /**
     * 
     * @type {Mime}
     * @memberof StorageFile
     */
    mime?: Mime;
    /**
     * 
     * @type {Features}
     * @memberof StorageFile
     */
    features: Features;
    /**
     * 
     * @type {string}
     * @memberof StorageFile
     */
    lastModified: string;
    /**
     * 
     * @type {number}
     * @memberof StorageFile
     */
    sizeInBytes?: number;
}

/**
* @export
* @enum {string}
*/
export enum StorageFileTypeEnum {
    File = 'file'
}

/**
 * 
 * @export
 * @interface StorageManual
 */
export interface StorageManual {
    /**
     * 
     * @type {string}
     * @memberof StorageManual
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StorageManual
     */
    type: StorageManualTypeEnum;
    /**
     * 
     * @type {Features}
     * @memberof StorageManual
     */
    features: Features;
    /**
     * 
     * @type {string}
     * @memberof StorageManual
     */
    lastModified: string;
    /**
     * 
     * @type {number}
     * @memberof StorageManual
     */
    elementsInside?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageManual
     */
    totalElementsInside?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageManual
     */
    sizeInBytes?: number;
}

/**
* @export
* @enum {string}
*/
export enum StorageManualTypeEnum {
    Manual = 'manual'
}

/**
 * 
 * @export
 * @interface StorageNode
 */
export interface StorageNode {
    /**
     * 
     * @type {string}
     * @memberof StorageNode
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StorageNode
     */
    type: StorageNodeTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof StorageNode
     */
    size?: number;
    /**
     * 
     * @type {Mime}
     * @memberof StorageNode
     */
    mime?: Mime;
    /**
     * 
     * @type {Features}
     * @memberof StorageNode
     */
    features: Features;
    /**
     * 
     * @type {string}
     * @memberof StorageNode
     */
    lastModified: string;
    /**
     * 
     * @type {number}
     * @memberof StorageNode
     */
    sizeInBytes?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageNode
     */
    elementsInside?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageNode
     */
    totalElementsInside?: number;
}

/**
* @export
* @enum {string}
*/
export enum StorageNodeTypeEnum {
    File = 'file',
    Directory = 'directory',
    Manual = 'manual',
    Bin = 'bin'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum StorageProviderType {
    WEBDAV = 0
}

/**
 * 
 * @export
 * @interface StorageWithIndexCount
 */
export interface StorageWithIndexCount {
    /**
     * 
     * @type {string}
     * @memberof StorageWithIndexCount
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof StorageWithIndexCount
     */
    id: number;
    /**
     * 
     * @type {StorageProviderType}
     * @memberof StorageWithIndexCount
     */
    provider: StorageProviderType;
    /**
     * 
     * @type {Features}
     * @memberof StorageWithIndexCount
     */
    features: Features;
    /**
     * 
     * @type {string}
     * @memberof StorageWithIndexCount
     */
    lastModified: string;
    /**
     * 
     * @type {string}
     * @memberof StorageWithIndexCount
     */
    lastBackup?: string;
    /**
     * 
     * @type {string}
     * @memberof StorageWithIndexCount
     */
    lastBackedUpBy?: string;
    /**
     * 
     * @type {ConnectionState}
     * @memberof StorageWithIndexCount
     */
    state: ConnectionState;
    /**
     * 
     * @type {IndexRefreshState}
     * @memberof StorageWithIndexCount
     */
    indexRefreshState: IndexRefreshState;
    /**
     * 
     * @type {string}
     * @memberof StorageWithIndexCount
     */
    lastIndexRefresh: string;
    /**
     * 
     * @type {string}
     * @memberof StorageWithIndexCount
     */
    tenant: string;
    /**
     * 
     * @type {WebDAVConfig}
     * @memberof StorageWithIndexCount
     */
    config: WebDAVConfig;
    /**
     * 
     * @type {number}
     * @memberof StorageWithIndexCount
     */
    indexCount: number;
}
/**
 * 
 * @export
 * @interface TableQuery
 */
export interface TableQuery {
    /**
     * 
     * @type {string}
     * @memberof TableQuery
     */
    query?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TableQuery
     */
    fullSearch?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TableQuery
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof TableQuery
     */
    itemsPerPage: number;
    /**
     * 
     * @type {Array<SortOption>}
     * @memberof TableQuery
     */
    sortBy?: Array<SortOption>;
}
/**
 * 
 * @export
 * @interface TableResultManual
 */
export interface TableResultManual {
    /**
     * 
     * @type {DataTableManual}
     * @memberof TableResultManual
     */
    data: DataTableManual;
    /**
     * 
     * @type {DataTableMeta}
     * @memberof TableResultManual
     */
    meta: DataTableMeta;
}
/**
 * 
 * @export
 * @interface TableResultSolrSearchResult
 */
export interface TableResultSolrSearchResult {
    /**
     * 
     * @type {DataTableSolrSearchResult}
     * @memberof TableResultSolrSearchResult
     */
    data: DataTableSolrSearchResult;
    /**
     * 
     * @type {DataTableMeta}
     * @memberof TableResultSolrSearchResult
     */
    meta: DataTableMeta;
}
/**
 * 
 * @export
 * @interface TableResultStorageWithIndexCount
 */
export interface TableResultStorageWithIndexCount {
    /**
     * 
     * @type {DataTableStorageWithIndexCount}
     * @memberof TableResultStorageWithIndexCount
     */
    data: DataTableStorageWithIndexCount;
    /**
     * 
     * @type {DataTableMeta}
     * @memberof TableResultStorageWithIndexCount
     */
    meta: DataTableMeta;
}
/**
 * 
 * @export
 * @interface Template
 */
export interface Template {
    /**
     * 
     * @type {number}
     * @memberof Template
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Template
     */
    path: string;
    /**
     * 
     * @type {string}
     * @memberof Template
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof Template
     */
    storage: number;
}
/**
 * 
 * @export
 * @interface WebDAVConfig
 */
export interface WebDAVConfig {
    /**
     * 
     * @type {WebDAVConfigAuthType}
     * @memberof WebDAVConfig
     */
    authType: WebDAVConfigAuthType;
    /**
     * 
     * @type {string}
     * @memberof WebDAVConfig
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof WebDAVConfig
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof WebDAVConfig
     */
    url: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum WebDAVConfigAuthType {
    None = 'none',
    Digest = 'digest',
    Password = 'password'
}

/**
 * 
 * @export
 * @interface WebDAVCreate
 */
export interface WebDAVCreate {
    /**
     * 
     * @type {WebDAVConfig}
     * @memberof WebDAVCreate
     */
    config: WebDAVConfig;
    /**
     * 
     * @type {Features}
     * @memberof WebDAVCreate
     */
    features: Features;
    /**
     * 
     * @type {string}
     * @memberof WebDAVCreate
     */
    name: string;
}
